/* Modal.tsx
   Version: 1.0.0
   Date: 2020-12-10
*/

// eslint-disable-next-line
import React from "react";
import ReactDOM from "react-dom";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ModalProps {
    children?: React.ReactNode,
    className?: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ModalState {
}


export default class Modal extends React.Component<ModalProps, ModalState> {

    private modalRoot: HTMLElement|null;
    private el: HTMLDivElement; 

    constructor(props: ModalProps) {
        super(props);
        this.el = document.createElement('div');
        this.modalRoot = document.getElementById('modal-root');
    }

    public componentDidMount(): void {
        if (this.modalRoot !== null) {
            this.modalRoot.appendChild(this.el);
        }
    }

    public componentWillUnmount(): void {
        if (this.modalRoot !== null) {
            this.modalRoot.removeChild(this.el);
        }
    }

    public render(): JSX.Element {
        return ReactDOM.createPortal(
            this.props.children,
            this.el,
        );
    }
}